import { useEffect, useState } from "react";

import ReceiptNoticeDesktop from "../assets/Home/AnnouncementPopUp/receipt.desktop.svg";
import ReceiptNoticeMobile from "../assets/Home/AnnouncementPopUp/receipt.mobile.svg";
import styles from "./news.modal.module.css";

const NewsModal = () => {
	const [modalVisible, setModalVisible] = useState(true);
	const [isMobile, setIsMobile] = useState(false);

	// checking if the user has visited the page and has seen the news modal //
	// useEffect(() => {
	// 	if (!localStorage.getItem("modalShown")) {
	// 	setModalVisible(true);
	// 	localStorage.setItem("modalShown", "true");
	// 	}
	// }, []);

	// const downloadImage = () => {
	// 	const link = document.createElement("a");
	// 	link.href = ESIRSJTBTIN;
	// 	link.download = "ESIRS JTB TIN";
	// 	document.body.appendChild(link);
	// 	link.click();
	// 	document.body.removeChild(link);
	// };

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth < 768);
		};

		handleResize(); // Set initial state based on current window size
		window.addEventListener("resize", handleResize);

		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	return (
		<>
			{modalVisible && (
				<>
					<div
						className={`${styles.modalOverlay} ${
							modalVisible ? styles.visible : styles.invisible
						}`}
						onClick={() => setModalVisible(false)}
					></div>
					<div
						className={styles.modalContent}
						onClick={(e) => e.stopPropagation()}
						aria-label="announcement modal"
					>
						<img
							style={{ width: "100%" }}
							src={
								isMobile
									? ReceiptNoticeMobile
									: ReceiptNoticeDesktop
							}
							alt="Enugu state governor 2-year anniversary"
							onClick={() => setModalVisible(false)}
						/>
					</div>
				</>
			)}
		</>
	);
};

export default NewsModal;
